import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconBasketShoppingRoundFill = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.96 3.994a1 1 0 0 1 .206 1.4L7.558 8.896h8.89l-2.607-3.502a1 1 0 1 1 1.604-1.195l3.497 4.697H21a1 1 0 0 1 0 2h-.51l-1.906 7.784a2 2 0 0 1-1.943 1.524H7.355a2 2 0 0 1-1.943-1.527l-1.894-7.781H3a1 1 0 1 1 0-2h2.064l3.498-4.697a1 1 0 0 1 1.399-.205Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconBasketShoppingRoundFill);
export default Memo;
